import { useLocation } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { useEffect } from "react";

const Layout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        // console.log(location.pathname, "location");
        setTimeout(() => {
            const loader = document.getElementById("preloader");
            if (loader) {
                loader.style.display = "none";
            }
        }, 500);
    }, [location])

    return (
        <>
            <div className="index_pepecoin" style={{ backgroundImage: "linear-gradient(to bottom, #893f41, #ffa4a3)" }}>
                <div className="page_wrapper">
                    {/* <div className="shape_leaf_top">
                        <img src="/assets/images/shapes/shape_leaf_1.webp" alt="Leaf" />
                    </div>
                    <div className="backtotop">
                        <a href="#" className="scroll">
                            <i className="fa-solid fa-arrow-up"></i>
                        </a>
                    </div> */}
                    <div id="preloader">
                        {/* <div className="line-1"></div>
                        <div className="line-2"></div>
                        <div className="line-3"></div>
                        <div className="line-4"></div> */}
                        <div className="global-loader">
                            <div className="loader" style={{ position: 'initial', opacity: '1' }}></div>
                            <div className="loder-section left-section"></div>
                            <div className="loder-section right-section"></div>
                        </div>
                    </div>

                    <Header />

                    <div className="router-wrapper">
                        {children}
                    </div>


                    <Footer />
                </div>
            </div>
        </>
    )
}

export default Layout;